// Feature subjects and actions for the per-user permission model. A FEATURE is
// a gated area of the app (e.g. the Dispatch Board); an action is what you can
// do with it (view / edit). Components gate UI with
// useAbility().can(<action>, <feature>).
//
// Action names are intentionally the literal `view` / `edit` from the
// permissions spreadsheet — they are plain CASL action strings.

export const FEATURES = {
  // Dashboard & Reports
  DASHBOARD: 'Dashboard', // /dashboard/*
  REPORTS: 'Reports', // /reports/*

  // Fleet
  VEHICLES: 'Vehicles', // /fleet/vehicles
  DRIVERS: 'Drivers', // /fleet/drivers, /fleet/drivers/list
  DRIVER_SHIFT: 'DriverShift', // /fleet/drivers/schedule (the shift scheduler)
  SHIFT_REPORT: 'ShiftReport', // /fleet/drivers/report
  TRIPS: 'Trips', // /fleet/trips
  DISPATCH_BOARD: 'DispatchBoard', // /fleet/dispatch, /fleet/dispatch/legacy
  DISPATCH_TEMPLATE: 'DispatchTemplate', // /fleet/dispatchtemplate/*
  FLEET_INSPECTION: 'FleetInspection', // /fleet/inspection

  // Rider services
  RESERVATIONS: 'Reservations', // /rider-services/reservations
  BOOKINGS: 'Bookings', // /rider-services/bookings/*
  SUBSCRIPTION: 'Subscription', // /rider-services/subscription
  NEM_TRANSPORT: 'NemTransport', // /rider-services/nem-transport
  BROKER_INTEGRATION: 'BrokerIntegration', // /rider-services/broker-integration
  MEMBERS: 'Members', // /rider-services/members/*
  RIDERS: 'Riders', // /rider-services/riders
  NOTIFICATIONS: 'Notifications', // /rider-services/notifications

  // Programs
  PROGRAMS_SERVICES: 'ProgramsServices', // /programs/services
  PROGRAMS_ACCOUNTS: 'ProgramsAccounts', // /programs/accounts
  PRICING: 'Pricing', // /programs/pricing

  // Account management
  ACCOUNT_USERS: 'AccountUsers', // /account_mngm/users
  ACCOUNT_BILLING: 'AccountBilling', // /account_mngm/plan-billing
  ACCOUNT_PAYMENT: 'AccountPayment', // /account_mngm/payment-method/*
};

export const FEATURE_ACTIONS = {
  VIEW: 'view',
  EDIT: 'edit',
};
